module.exports = __webpack_public_path__ + "static/media/mmsys_123.55ae47fe.ico";